import * as React from "react";
import classnames from "classnames";
import { Hr } from "@grandvisionhq/elements";
/* empty css                            */
import { useEcommFacetContext } from "../../../../context/modules/EcommContent/context/EcommFacetContext.js";
import { useSunglassesEcommContext } from "../../../context/modules/EcommContent/SunglassesEcommContent/context/SunglassesEcommContext.js";
import { useProductDetailSlots } from "../../../../../../slots/slots/context.js";
import { ProductTag } from "../../../../components/ProductTag/modules/EcommContent/components/ProductTag/ProductTag.js";
import { SunglassesPriceSection } from "../../../components/SunglassesPriceSection/modules/EcommContent/SunglassesEcommContent/components/SunglassesPriceSection/SunglassesPriceSection.js";
import { SunglassesRxableSelectContainer } from "../../../components/SunglassesRxableSelect/modules/EcommContent/SunglassesEcommContent/components/SunglassesRxableSelect/SunglassesRxableSelectContainer.js";
import { SunglassesCTA } from "../../../components/SunglassesCTA/modules/EcommContent/SunglassesEcommContent/components/SunglassesCTA/SunglassesCTA.js";
import { useSunglassesProductData } from "../../../../../../context/context/product-context-hooks.js";
import { VariantSelectorTree } from "../../../../components/VariantSelectorTree/modules/EcommContent/components/VariantSelectorTree/VariantSelectorTree.js";
const SunglassesEcommContent = ({ className, ctaRef }) => {
  const {
    activeVariant: { displayName, sku: activeSku, isExcludedFromCheckout },
    product
  } = useSunglassesProductData();
  const { isValid, setNotificationType } = useEcommFacetContext();
  const triggerAlertMessage = () => setNotificationType("error");
  const { handleConfiguratorClose, isConfiguratorOpen, shouldOpenConfigurator } = useSunglassesEcommContext();
  const { isOfferedWithPrescriptions } = product;
  const { Slots } = useProductDetailSlots();
  return /* @__PURE__ */ React.createElement("section", { "aria-label": displayName, className: classnames("sunglasses-ecomm-content", className) }, /* @__PURE__ */ React.createElement(ProductTag, { className: "sunglasses-ecomm-content__tag" }), /* @__PURE__ */ React.createElement(SunglassesPriceSection, null), /* @__PURE__ */ React.createElement(Hr, null), /* @__PURE__ */ React.createElement(VariantSelectorTree, null), isOfferedWithPrescriptions && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SunglassesRxableSelectContainer, null), /* @__PURE__ */ React.createElement(Hr, null)), /* @__PURE__ */ React.createElement("div", { className: "sunglasses-ecomm-content__column" }, Slots.DynamicDeliveryIndicator ? /* @__PURE__ */ React.createElement(
    Slots.DynamicDeliveryIndicator,
    {
      isExcludedFromCheckout,
      deliveryItems: [{ sku: activeSku, quantity: 1 }],
      hasRxLens: shouldOpenConfigurator,
      className: "sunglasses-ecomm-content__delivery-indicator"
    }
  ) : null, /* @__PURE__ */ React.createElement("div", { ref: ctaRef }, /* @__PURE__ */ React.createElement(SunglassesCTA, null)), Slots.AfterCTA ? /* @__PURE__ */ React.createElement(
    Slots.AfterCTA,
    {
      sku: activeSku,
      onInvalidClick: !isValid ? triggerAlertMessage : void 0
    }
  ) : null), Slots.Configurator && /* @__PURE__ */ React.createElement(
    Slots.Configurator,
    {
      id: "rxSun",
      onModalClose: handleConfiguratorClose,
      isOpen: isConfiguratorOpen
    }
  ));
};
export {
  SunglassesEcommContent
};
//# sourceMappingURL=SunglassesEcommContent.js.map
